import './sidebar-layout.css';

import UserInactiveInfo from 'app-sections/common/users/user-inactive-info/UserInactiveInfo';
import UpdatesListenerWrapper from 'app-sections/common/websockets/updates-listener-wrapper/UpdatesListenerWrapper';
import { Outlet } from 'react-router-dom';
import AppMessageOverlay from 'ui/components/app-message-overlay/AppMessageOverlay';
import ScrollController from 'ui/components/scroll-controller/ScrollController';

import LayoutErrorBoundary from '../../../errors/LayoutErrorBoundary';
import AppSidebar from '../app-sidebar/AppSidebar';
import AppToolbar from '../app-toolbar/AppToolbar';
import { isProduction } from 'ui/helpers/env';

export default function SidebarLayout() {
  return (
    <div className="root">
      <UserInactiveInfo />
      <AppSidebar />
      <div className="layout-wrapper">
        <AppToolbar />
        <main className="content" id="main-scroll-container">
          <LayoutErrorBoundary>
            <ScrollController />
            <UpdatesListenerWrapper />
            <Outlet />
            {/* <CustomRoutesProvider mobileAnimationType="opacity" /> */}
          </LayoutErrorBoundary>
        </main>
      </div>
      {!isProduction() && <AppMessageOverlay />}
    </div>
  );
}
